import Reveal from "./Reveal.jsx";
import { projects } from "../data/data.jsx";
import "./Projects.css";

export default function Projects() {
  return (
    <section id="projects">
      <div className="wrap">
        <Reveal className="section-head">
          <div className="eyebrow">
            <span className="dot"></span>PROJECTS
          </div>
          <h2>Selected work</h2>
        </Reveal>

        <div className="projects">
          {projects.map((project) => (
            <Reveal
              as="div"
              className={`proj-card ${project.featured ? "featured" : ""}`.trim()}
              key={project.title}
            >
              {project.image && (
                <div className="proj-image">
                  <img
                    src={project.image}
                    alt={project.imageAlt || `${project.title} UI preview`}
                    loading="lazy"
                  />
                </div>
              )}

              <div className="proj-top">
                <div>
                  <h3>{project.title}</h3>
                  <div className="proj-sub">{project.sub}</div>
                </div>
                <div className="proj-status">
                  <span className="pt2"></span>
                  {project.status}
                </div>
              </div>
              <p className="desc">{project.desc}</p>
              <div className="tag-row">
                {project.tags.map((tag) => (
                  <span className="tag" key={tag}>
                    {tag}
                  </span>
                ))}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
